import { ApiClient } from "../../../Services/apiService";
import { Gen } from "../../../Services/api";

export class ExFactoryService {
    static componentName = "exFactoryService";
    static $inject = [ApiClient.componentName, "exFactoryCalculation"];

    constructor(protected apiClient: ApiClient, protected exFactoryCalculation: $TSFixMe) {}

    calculateExFactory(
        forecastMethod: $TSFixMe,
        forecastType: $TSFixMe,
        forecastStartDate: $TSFixMe,
        historicalDataStart: $TSFixMe,
        skus: $TSFixMe
    ) {
        const request = {
            forecastStartDate,
            historicalDataStart,
            skus: skus.map((s: $TSFixMe) => ({
                forecast: this.getForecast(s, forecastMethod),
                oracleCode: s.oracleIndex,
                dddFactor: s.dddFact,
                launchDate: s.forecast.exFactory.launchDate,
                freezedMonthsVolume: angular._get(s, "forecast.exFactory.freezedMonthsVolume", []),
                unit: "volume",
                sales: angular._get(s, "forecast.exFactory.sales", null),
                salesFrom: angular._get(s, "forecast.exFactory.salesFrom", null),
                salesTo: angular._get(s, "forecast.exFactory.salesTo", null),
                rotation: angular._get(s, "forecast.exFactory.rotation", null),
                itemsInStock: angular._get(s, "forecast.exFactory.itemsInStock", null),
                itemsInStockDate: angular._get(s, "forecast.exFactory.itemsInStockDate", null),
                algorithmType: s.forecast.exFactory.algorithmType,
                historicalData: {
                    value: s.forecast.exFactory.historicalValueData,
                    volume: s.forecast.exFactory.historicalVolumeData
                }
            }))
        };

        return this.apiClient.calculateExFactory(request).then(response => {
            const result = {
                skusVolume: [] as any[],
                skusValue: [] as any[]
            };

            for (const serverSku of response) {
                const sku = skus.find((s: $TSFixMe) => serverSku.oracleCode == s.oracleIndex);
                const header =
                    sku.name +
                    " - " +
                    Math.floor(serverSku.rotation! + 0.5) +
                    "/" +
                    angular._get(serverSku, "itemsInStock", 0);
                result.skusVolume.push({
                    name: sku.name,
                    header: header,
                    values: serverSku.historicalData.volume.concat(serverSku.forecast)
                });

                const valueForecast = this.exFactoryCalculation.calculateExFactoryValue(
                    sku,
                    serverSku.forecast,
                    forecastType == "dot"
                );
                result.skusValue.push({
                    name: sku.name,
                    header: header,
                    values: serverSku.historicalData.value.concat(valueForecast)
                });
            }
            return result;
        });
    }

    private getForecast(sku: $TSFixMe, forecastMethod: $TSFixMe) {
        switch (forecastMethod) {
            case "sku":
                return sku.forecast.pmForecast;
            default:
                return sku.forecast.volume.pmForecast;
        }
    }
}

angular.module("topline.services").service(ExFactoryService.componentName, ExFactoryService);
